import React, { useEffect, useMemo, useState } from 'react'
import LabelText from '../../../ui/LabelText'
import { useSearch } from '../../../contexts/PlayerSearchContext';
import CloseIcon from '@mui/icons-material/Close';
import { ForawrdBackwardButton } from '../../../styled-components/PageHeaderStyles';
import SecondaryButton from '../../../ui/SecondaryButton';
import SearchInput from '../../../ui/SearchInput';
import { IPositionSearchByZoneResponse } from '../../../types/IPositionSearchByZoneResponse';
import Pitch from '../../Pitch';
import { IZoneArray } from '../../../types/IPitchProps';
import { useSidebar } from '../../../contexts/SidebarContext';
import { IPlayerSearchResponse } from '../../../types/IPlayerSearchResponse';
import { fetchData, postData } from '../../../services/api';
import handleApiResponse from '../../../utils/handleApiResponse';
import IApiResponse from '../../../types/IApiResponse';
import apiUrls from '../../../config/apiUrls';
import CustomList from '../../../ui/CustomList';
import PrimaryButton from '../../../ui/PrimaryButton';
import { styled } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLoading } from '../../../contexts/LoadingContext';
import { CheckboxInput } from '../../../ui/FilterDropdown';
import LabelNumber from '../../../styled-components/LabelNumber';
import NumberTextField from '../../../ui/NumberTextField';
import RadioButton from '../../../ui/CustomRadioButton';
import { AttributesList } from '../../../styled-components/PlayerComponent.styles';
import { attributeSections } from '../../../data/attributeSection';
import { Drawer } from "@mui/material";
import { ModuleSpinner } from '../../../ui/LoadingSpinner/ModuleSpinner';
import PlayerSearchList from '../../PlayerLanding/PlayerSearch/PlayerSearchList';
import { filterWomensFootball } from '../../../utils/womensFootballFilter';

import { ISection } from '../../PlayerLanding/PlayerSearch/SelectAttributes';
import { IArchetypeInfo, ITypicalPlayerExample } from '../../PlayerLanding/PlayerSearch/PlayerSearchInit';
import { IPlayerComparisonData } from '../../../types/IPlayerComparison';

interface PlayerInitialSearchProps {
    onCloseDrawer: () => void;
}

const SearchResults = styled.div`   
    background: ${({ theme }) => theme.searchResultsFooterBackground};
    backdrop-filter: blur(32px); 
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    -webkit-backdrop-filter:  blur(32px); 
`;

const DrawerContainer = styled.div`   
    background: ${({ theme }) => theme.playerContentBackground};
`;

const AttributesContent = styled.div`
    border-top: 1px solid ${({ theme }) => theme.playerDataBorder};
`;
const PlayersPosition = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
`;
const options = [
    { label: 'Their position', value: 'theirposition' },
    { label: 'All positions', value: 'allpositions' },
];
interface IPlayerSimulationSearchProps{
  open: boolean;
  setIsOpen: (open:boolean) => void;
  archtypeId?: number;
  headerLabel: string;
  onAddToShortlist?: (player: IPlayerSearchResponse) => void;
  playerComparisonTableData?:IPlayerComparisonData[];
}

const SimulationPlayerSearch : React.FC<IPlayerSimulationSearchProps> = ({open , setIsOpen , archtypeId , headerLabel , onAddToShortlist, playerComparisonTableData }) => {
    const navigate = useNavigate();
    const { loading, startLoading, stopLoading } = useLoading();
    const { isOpen, toggleSubSidebar, subMenuOpen, toggleSidebar, toggleDrawer } = useSidebar();
    const { handleSelectedZoneIdsChange, searchData, searchText, setSearchData, setSearchText
        , handleSelectedProfiles, setIsActiveButton, handleOriginPage, setIsClubsSelected, handleSelectedPlayers,
        setIsFilterChange, setIsSearchByAttributes, handleSelectedAttributes, setIsAllPosition, handleSelectedTags , selectedPositionIds , setSelectedPositionIds } = useSearch();
    const [zonePositionList, setZonePositionList] = useState<IPositionSearchByZoneResponse[]>([]);
    const [active, setActive] = useState<string | null>(null);
    const [selectedItems, setSelectedItems] = useState<IPlayerSearchResponse[]>([]);
    const [selectedProfileItems, setSelectedProfileItems] = useState<IPositionSearchByZoneResponse[]>([]);
    const [selectedProfiles, setSelectedProfiles] = useState<number[]>([]);
    const [selectedAreas, setSelectedAreas] = useState<number[]>([]);
    const [clearInput, setClearInput] = useState(false);
    const [isAddAttributes, setIsAddAttributes] = useState<boolean>(false);
    const [sectionsState, setSectionsState] = useState<ISection[]>(attributeSections);
    const [selectedOption, setSelectedOption] = useState<string>('allpositions');
    const [moduleLoading, setModuleLoading] = useState<boolean>(false);
    const [typicalPlayerExamples, setTypicalPlayerExamples] = useState<
      ITypicalPlayerExample[]
    >([]);
    const [searchItemsFromStorage, setSearchItemsFromStorage] = useState<number[]>(JSON.parse(localStorage.getItem("PlayerSearchItem")!)?.reverse());

    const clearPreviousSearches = () => {
      localStorage?.removeItem("PlayerSearchItem");
      setSearchItemsFromStorage([]);
    };
    

    useEffect(() => {
        const fetchArchetypeInfoData = async () => {
        try {
            setModuleLoading(true);
            const response: IApiResponse<IArchetypeInfo> = await fetchData(
            `${apiUrls["GetArchetypeDetails"]}/${archtypeId}`
            );
            if (response.isSuccess) {
            setModuleLoading(false);
            setTypicalPlayerExamples(filterWomensFootball(response?.data?.typicals || []));
            return response;
            }

        } catch (error) {
            setModuleLoading(false);
            return console.log(
            "500",
            "API call failed due to an internal server error"
            );
        }
        };
        if (archtypeId) {
        fetchArchetypeInfoData();
        }
    }, [archtypeId]);

    const handleClose = () => {
        setIsOpen(!open)
        // toggleDrawer?.(false);
        // toggleSidebar?.(false);
        setSearchText("");
        setSearchData?.([]);
    };

    const handleSearch = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (value.length >= 3) {
            setSearchText(value);
            try {
                const response: IApiResponse<IPlayerSearchResponse[]> = await fetchData(`${apiUrls['PlayerSearch']}?searchQuery=${value}`);
                handleApiResponse(response, (playerSearchData) => {
                    setSearchData?.(filterWomensFootball(playerSearchData));
                }, (error) => {

                    console.error('Error fetching Player Search Data:', error);
                });
            } catch (error) {
                console.error('Error fetching Player Search Data:', error);
            }
        }
        else {
            setSearchData?.([]);
        }
    };

    const handleClear = () => {
        setSearchText("");
        setSearchData?.([]);
    };



    const handleSelect = (item: IPlayerSearchResponse | IPlayerSearchResponse[] | null, selected: boolean) => {};


    const renderSearchPlayers = () => {
        return (
            searchData && searchData?.length > 0 && (
                <div className='player-profile-list padding-bottom'>
                    <PlayerSearchList
                        searchData={searchData}
                        searchText={searchText}
                        onSelect={handleSelect}
                        selectedItems={selectedItems}
                        multiSelection={false} //isAdding
                        iconType='image'
                        displayCheckBox={false}
                        isForComparePlayerASrchtype={true}
                        isForSimulation={true}
                        onAddToShortlist={onAddToShortlist}
                        playerComparisonTableData={playerComparisonTableData}
                        />
                </div>
            ))
    }

    

    return (
        <Drawer
                  PaperProps={{
                    style: {
                      left: "70px",
                      backgroundColor: "#F9FAF7",
                      backdropFilter: "blur(16px)",
                      width: "420px",
                      zIndex: "99999",
                    },
                  }}
                  anchor="left"
                  variant="persistent"
                  open={open}
                  onClose={handleClose}
              >
            <DrawerContainer className='main-drawer-container'>
                <div className='drawer-header'>
                    <LabelText className='drawer-title'>{headerLabel}</LabelText>
                    <div className='header-buttons'>
                       
                        <ForawrdBackwardButton onClick={handleClose}>
                            <CloseIcon className='cta-btn-icons' />
                        </ForawrdBackwardButton>
                    </div>
                </div>
                <div className='player-search-data'>
                    <div
                        className='container active'
                    >
                        <SearchInput
                            handleSearch={handleSearch}
                            handleClear={handleClear}
                            placeholder='Search players'
                            fontSize='32px'
                            type="SearchPlayer"
                            clearInput={clearInput}
                            autoFocus={false}
                        />
                        </div>
                        {renderSearchPlayers()}
                        {moduleLoading && ( <ModuleSpinner/>)}
                        {archtypeId && (
                            <div className="individuas-pitch-player-conatiner">
                                <div className="typical-exmaples-container">
                                    <LabelText className="player-search-text">Similar playing style - most successful</LabelText>
                                    <div className="individual-typical-player-container">
                                    <div className="player-profile-list padding-bottom">
                                        <PlayerSearchList
                                        searchData={typicalPlayerExamples}
                                        searchText={""}
                                        selectedItems={[]}
                                        multiSelection={false}
                                        iconType="image"
                                        displayCheckBox={false}
                                        isForComparePlayerASrchtype={true}
                                        isForSimulation={true}

                                        />
                                    </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {searchItemsFromStorage?.length > 0 && (
                            <div className="previous-search-container">
                                <div className="previous-search-header">
                                <p>Previous searches</p>
                                <p onClick={() => clearPreviousSearches()}>Clear</p>
                                </div>
                                <div className="player-profile-list padding-bottom">
                                <PlayerSearchList
                                    searchData={searchItemsFromStorage}
                                    searchText={""}
                                    selectedItems={[]}
                                    multiSelection={false}
                                    iconType="image"
                                    displayCheckBox={false}
                                    isForComparePlayerASrchtype={true}
                                    isForSimulation={true}

                                    />
                                </div>
                            </div>
                        )}
                </div>

            </DrawerContainer>
        </Drawer>
    )
}

export default SimulationPlayerSearch;
